import menComing from 'assets/icons/men-coming-icon.svg';
import { Img, ImgSize } from 'shared/ui/imgStyledComponent';

type MenComingIconProps = {
	size?: ImgSize;
};

export const MenComingIcon: React.FC<MenComingIconProps> = ({ size }) => {
	return <Img role="image" src={menComing} $size={size} />;
};
